// @flow
import { combineReducers } from 'redux';

import * as common from './common';
import * as types from '../types/changeStopRequest';
import type {
  CHANGE_STOP_REQUEST_ACTION_TYPE,
  CHANGE_STOP_REQUEST_TYPE,
} from '../types/changeStopRequest';
import type { ERROR_TYPE } from '../types/common';

export type ChangeStopRequestState = {
  byId: {[number]: CHANGE_STOP_REQUEST_TYPE},
  order: Array<number>,
  fetching: Array<number>,
  current: number,
  nextPage: number,
  stateFilter: string,
  isFetching: boolean,
  error: ERROR_TYPE,
  counter: number,
};


const byId = common.byId({
  added: [types.CHANGE_STOP_REQUEST_FETCH_FINISHED],
  fetched: [
    types.CHANGE_STOP_REQUEST_FETCH_FINISHED,
    types.CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS,
  ],
  removed: [],
  updated: [
    types.CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS,
  ],
  defaultAttributes: {},
});

const fetching = common.fetching({
  started: [
    types.CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED,
    types.CHANGE_STOP_REQUEST_FETCH_STARTED,
  ],
  succeed: [
    types.CHANGE_STOP_REQUEST_FETCH_FINISHED,
    types.CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS,
  ],
  failed: [
    types.CHANGE_STOP_REQUEST_FETCH_FAILED,
    types.CHANGE_STOP_REQUEST_CHANGE_STATE_FAILED,
  ],
});

const isFetching = common.isFetching({
  started: [
    types.CHANGE_STOP_REQUEST_FETCH_STARTED,
  ],
  failed: [types.CHANGE_STOP_REQUEST_FETCH_FAILED],
  succeed: [
    types.CHANGE_STOP_REQUEST_FETCH_FINISHED,
  ],
});

const isChangingState = common.isFetching({
  started: [types.CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED],
  failed: [types.CHANGE_STOP_REQUEST_CHANGE_STATE_FAILED],
  succeed: [types.CHANGE_STOP_REQUEST_CHANGE_STATE_SUCCESS],
});

const error = common.error({
  populate: [
    types.CHANGE_STOP_REQUEST_FETCH_FAILED,
    types.CHANGE_STOP_REQUEST_CHANGE_STATE_FAILED,
    types.CHANGE_STOP_REQUEST_CREATE_FAILED,
  ],
  clear: [types.CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED, types.CHANGE_STOP_REQUEST_FETCH_STARTED],
});

const order = common.order({
  fetched: [types.CHANGE_STOP_REQUEST_FETCH_FINISHED],
  added: [
    types.CHANGE_STOP_REQUEST_FETCH_FINISHED,
  ],
});

const stateFilter = (state: string = 'pending', action: CHANGE_STOP_REQUEST_ACTION_TYPE): string => {
  switch (action.type) {
    case types.CHANGE_STOP_REQUEST_CHANGE_VIEW_FILTER: {
      return action.payload;
    }
    default:
      return state;
  }
};

const nextPage = (
  state: ?number = null,
  action: CHANGE_STOP_REQUEST_ACTION_TYPE,
): ?number => {
  switch (action.type) {
    case types.CHANGE_STOP_REQUEST_FETCH_FINISHED: {
      const { next } = action.payload;
      return next != null ? Math.max(state || -1, next) : null;
    }
    case types.CHANGE_STOP_REQUEST_FETCH_FAILED: {
      return null;
    }

    default: {
      return state;
    }
  }
};

const counter = common.mux({
  selected: [types.FETCH_CHANGE_STOP_REQUEST_COUNTER_SUCCEED],
  default: -1,
});


const changeStopRequests = combineReducers({
  byId,
  fetching,
  isFetching,
  isChangingState,
  error,
  stateFilter,
  order,
  nextPage,
  counter,
});

export default changeStopRequests;


export const isFetchingChangeStopRequest = (
  state: ChangeStopRequestState,
): boolean => state.isFetching;
export const isChangingStateRequest = (
  state: ChangeStopRequestState,
): boolean => state.isChangingState;
export const getChangeStopRequest = (
  state: ChangeStopRequestState,
  id: number,
): CHANGE_STOP_REQUEST_TYPE => state.byId[id];
export const getChangeStopRequests = (
  state: ChangeStopRequestState,
  localStateFilter: string,
): Array<CHANGE_STOP_REQUEST_TYPE> => {
  if (!state) {
    return state.order.map(id => state.byId[id]);
  }

  return (
    state.order.map(
      id => state.byId[id],
    ).filter(
      elm => {
        if (localStateFilter === 'pending') {
          return elm.state === localStateFilter;
        } else {
          return elm.state !== 'pending';
        }
      },
    )
  );
};
export const isChangeStopRequestfetching = (
  state: ChangeStopRequestState,
  id: number,
): boolean => state.fetching.includes(id);
export const getChangeStopRequestFetchingError = (
  state: ChangeStopRequestState,
): ERROR_TYPE => state.error;
export const getChangeStopRequestIds = (
  state: ChangeStopRequestState,
): Array<number> => state.order;
export const getStateTypeChangeStopRequests = (
  state: ChangeStopRequestState,
): string => state.stateFilter;

export const hasMoreChangeStopRequests = (
  state: ChangeStopRequestState,
): boolean => {
  return (state.nextPage != null) && !state.isFetching;
};

export const areChangeStopRequestsFetching = (
  state: ChangeStopRequestState,
): boolean => state.isFetching;

export const getChangeStopRequestPendingCounter = (
  state: ChangeStopRequestState,
): number => state.counter;



// WEBPACK FOOTER //
// ./src/scripts/reducers/changeStopRequest.js